import { BatchStatus, SystemAddOn } from "node-library/dist/constants";
import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import {
	FrontendBatchType,
	FrontendCompanyTestCategory,
	FrontendCompanyWithAdditionalInfomation,
	FrontendSampleSpecification,
	FrontendSampleSpecificationDirectory,
	FrontendUserInfo,
} from "node-library/dist/portal";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Card, Divider } from "@mui/material";
import { NeutralColor, PrimaryColor } from "node-library/dist/colors";
import {
	BlackButton,
	CustomIconButton,
	DropdownButton,
	GreenButton,
} from "../../../common-components/button";
import { NavBar } from "../../../common-components/navbar";
import { EditIcon, UserIcon } from "../../../common-components/svgIcons";
import { useSnackbar } from "../../../common-components/toast/showToastMessage";
import { getContentContainer } from "../../../helpers/containerHelper";

import { FrontendBatchPageTestBatchDetails } from "node-library/dist/structures/frontendSampleTestBatchPageDefinitions";
import {
	findCompanyBatchTypeById,
	getBatchStatusColors,
	getBatchStatusTranslationString,
	getDefaultOtherTestBatchType,
} from "../../../helpers/testBatchHelper";
import BatchInstancesTable from "./components/batchInstancesTable";
import EditBatchStatusModal from "./components/editBatchStatusModal";
import {
	hasPermission,
	PermissionMap,
	Permissions,
} from "node-library/dist/permissions";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>;
	user: FrontendUserInfo;
	batchDetails: FrontendBatchPageTestBatchDetails;

	goBackToPreviousPage: (reload: boolean) => void;
	specDirectories: Array<FrontendSampleSpecificationDirectory>;
	updateSpecification: (spec: FrontendSampleSpecification) => void;
}

export default function BasicBatchDetailsContent(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const {
		batchDetails,
		goBackToPreviousPage,
		user,
		company,
		setCompany,
		specDirectories,
		updateSpecification,
	} = props;

	//order updatable fields
	const [batchStatus, setBatchStatus] = useState<BatchStatus>(
		batchDetails.batchStatus,
	);

	const [createdTime, setCreatedTime] = useState<Date | undefined>(
		batchDetails.inserted ? new Date(batchDetails.inserted) : undefined,
	);
	const [loading, setLoading] = useState<boolean>(false);

	const dueDate: Date = batchDetails.dueDate as Date;

	const [resultSubmitTime, setResultSubmitTime] = useState<Date | undefined>(
		batchDetails.resultSubmitTime
			? new Date(batchDetails.resultSubmitTime)
			: undefined,
	);
	const [completeTime, setCompleteTime] = useState<Date | undefined>(
		batchDetails.completeTime ? new Date(batchDetails.completeTime) : undefined,
	);

	const [comments, setComments] = useState<string>(batchDetails.comments || "");

	const [editStateTimeModalOpen, setEditStateTimeModalOpen] =
		useState<boolean>(false);

	const userHasUpdateStatusTimePermission: boolean = hasPermission(
		user.role?.permissions as PermissionMap,
		Permissions.batches.updateStatus,
	);

	// const isInAdminView: boolean = checkUserTypeMeetsRequirement(
	// 	user?.role as SystemRole,
	// 	SystemRole.ADMIN
	// );

	const testCategory: FrontendCompanyTestCategory =
		company.companyTestCategories.find((category) => {
			return category.testCategoryId == batchDetails.mainTestCategoryId;
		}) as FrontendCompanyTestCategory;
	const isOtherTestBatch: boolean = batchDetails.isOtherTestBatch;

	const batchType: FrontendBatchType = isOtherTestBatch
		? getDefaultOtherTestBatchType(testCategory.testCategoryId, translation)
		: (findCompanyBatchTypeById(
				company,
				testCategory.testCategoryId,
				batchDetails.batchTypeId || "",
			) as FrontendBatchType);

	let statusString: string;
	let statusColor: {
		backgroundColor: string;
		borderColor: string;
		textColor: string;
	};
	let statusDescriptionString: string;

	statusString = getBatchStatusTranslationString(batchStatus, translation);
	statusColor = getBatchStatusColors(batchStatus);

	const batchCreationDate: string = createdTime
		? formatCustomDate(createdTime)
		: "";

	const navbarItems: Array<{
		label: string;
		onClick: () => void;
		isCurrentItem: boolean;
	}> = [
		{
			label: translation("Batches"),
			onClick: () => goBackToPreviousPage(false),
			isCurrentItem: false,
		},
		{
			label: translation("Details"),
			onClick: () => {},
			isCurrentItem: true,
		},
	];

	let actionButtonOptions: Array<{
		key: string;
		onClick: () => void;
		icon: React.ReactNode;
		text: string;
		widthToShow?: number;
	}> = [];
	let keyActionOption: {
		key: string;
		onClick: () => void;
		children: any;
		disabled?: boolean;
	} = {
		key: "view-order",
		onClick: () => {
			console.log("asdf");
		},
		children: translation("StartBatch"),
	};

	// switch (orderStatus) {
	// 	case OrderStatus.IN_PROGRESS:
	// 	case OrderStatus.COMPLETE:
	// 		actionButtonOptions = [
	// 			{
	// 				key: "view-coc",
	// 				onClick: () => {
	// 					viewOrderCOC(order);
	// 				},
	// 				widthToShow: 780,
	// 				icon: <COAIcon />,

	// 				text: translation("ChainOfCustody"),
	// 			},
	// 			{
	// 				key: "copy-instance-export-data",
	// 				onClick: () => {
	// 					copyInstanceExportData();
	// 				},
	// 				icon: <CopyIcon size={20} />,

	// 				text: translation("Copyexportdata"),
	// 			},

	// 			{
	// 				key: "view-add-reports",
	// 				onClick: () => {
	// 					goToOrderReportPage(order);
	// 				},
	// 				icon: <UploadIcon size={20} />,

	// 				text: translation("Uploadreports"),
	// 			},
	// 			{
	// 				key: "discard-order",
	// 				onClick: () => {
	// 					setProceedAction(() => () => deleteOrder(order));
	// 					setDiscardOrderConfirmOpen(true);
	// 				},
	// 				icon: <ClearIcon sx={{ fontSize: "20px" }} />,

	// 				text: translation("Discardorder"),
	// 			},
	// 		];
	// 		break;
	// }

	let actionButton: React.ReactNode = <></>;
	if (actionButtonOptions.length == 1) {
		actionButton = (
			<BlackButton
				id={"order-details-actionbutton"}
				buttonClassName={
					actionButtonOptions[0].widthToShow
						? "order-details-inprogress-action-button"
						: ""
				}
				onClick={(e) => {
					actionButtonOptions[0].onClick();
				}}
			>
				{actionButtonOptions[0].text}
			</BlackButton>
		);
	} else if (actionButtonOptions.length > 1) {
		actionButton = (
			<DropdownButton
				buttonColor="black"
				id={"order-details-actionbutton"}
				container={getContentContainer()}
				menuOptions={actionButtonOptions.map((option) => {
					return {
						...option,
						children: (
							<div className="icon-dropdown-menu-item">
								{option.icon}
								{option.text}
							</div>
						),
					};
				})}
				onClick={(e) => {}}
			>
				{translation("Actions")}
			</DropdownButton>
		);
	}

	const buttonPanel: React.ReactNode = (
		<div
			style={{
				display: "flex",
				gap: "5px",
				justifyContent: "center",
				flexWrap: "wrap",
			}}
		>
			{actionButton}

			<GreenButton
				id={"order-details-key-action-button"}
				onClick={keyActionOption.onClick}
				disabled={keyActionOption.disabled}
			>
				{keyActionOption.children}
			</GreenButton>
		</div>
	);

	const batchDetailsHeaderRow: React.ReactNode = (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				gap: "10px",
				flexWrap: "wrap",
			}}
		>
			<div>
				<div style={{ marginLeft: "35px" }}>
					<NavBar items={navbarItems}></NavBar>
				</div>

				<div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
					<CustomIconButton
						id="order-details-back-button"
						size="small"
						onClick={() => {
							goBackToPreviousPage(false);
						}}
						icon={<KeyboardArrowLeftIcon />}
					></CustomIconButton>

					<div
						className="typography-heading-01"
						style={{ display: "flex", alignItems: "center", gap: "5px" }}
					>
						{`${translation("Batch")} ${batchDetails.batchFullCode}`}
					</div>
				</div>
			</div>
			{buttonPanel}
		</div>
	);

	const orderDetailsCardRow: React.ReactNode = (
		<div className="instance-details-card-row">
			<Card className="card-border-radius-14p card-medium-padding">
				<div className="order-details-header-card-content">
					<div>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								gap: "10px",
							}}
						>
							<div
								className="typography-body-01 typography-bold admin-sample-status-box"
								style={{
									backgroundColor: statusColor.backgroundColor,
									border: `1px solid ${statusColor.borderColor}`,
									color: statusColor.textColor,
									minWidth: "20%",
								}}
							>
								{statusString}
							</div>
							{userHasUpdateStatusTimePermission && (
								<div
									style={{ cursor: "pointer" }}
									onClick={() => {
										setEditStateTimeModalOpen(true);
									}}
								>
									<EditIcon strokeColor={NeutralColor.NEUTRAL_GREY_950} />
								</div>
							)}
						</div>
						{/* <div
							className="typography-caption"
							style={{ color: NeutralColor.NEUTRAL_GREY_500, marginTop: "5px" }}
						>
							{statusDescriptionString}
						</div> */}
					</div>
					<div>
						<div className="order-details-time-grid">
							<div className="order-details-time-grid-item">
								<div
									className="typography-caption"
									style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
								>
									{translation("BatchCreatedOn")}
								</div>
								<div className="typography-body-01 typography-bold">
									{batchCreationDate ? batchCreationDate.split(" | ")[0] : "--"}
								</div>
								<div className="typography-caption">
									{batchCreationDate ? batchCreationDate.split(" | ")[1] : ""}
								</div>
							</div>
							<Divider orientation="vertical" flexItem></Divider>

							<div className="order-details-time-grid-item">
								<div
									className="typography-caption"
									style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
								>
									{translation("ResultSubmittedOn")}
								</div>
								<div
									className="typography-body-01 typography-bold"
									style={{
										color: NeutralColor.NEUTRAL_GREY_500,
									}}
								>
									{resultSubmitTime
										? formatCustomDate(resultSubmitTime).split(" | ")[0]
										: "--"}
								</div>
								<div className="typography-caption">
									{resultSubmitTime
										? formatCustomDate(resultSubmitTime).split(" | ")[1]
										: ""}
								</div>
							</div>
							<Divider orientation="vertical" flexItem></Divider>

							<div className="order-details-time-grid-item">
								<div
									className="typography-caption"
									style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
								>
									{translation("CompletedOn")}
								</div>
								<div
									className="typography-body-01 typography-bold"
									style={{
										color: completeTime ? PrimaryColor.PRIMARY_500 : "black",
									}}
								>
									{completeTime
										? formatCustomDate(completeTime).split(" | ")[0]
										: "--"}
								</div>
								<div className="typography-caption">
									{completeTime
										? formatCustomDate(completeTime).split(" | ")[1]
										: ""}
								</div>
							</div>
						</div>
						{/* <Divider orientation="horizontal" flexItem></Divider>
						<div>
							<div className="order-details-time-grid-item">
								<div
									className="typography-caption"
									style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
								>
									{translation("EstimatedCompletionDate")}
								</div>
								<div className="order-details-eta-time-grid">
									{
										<div>
											<div
												className="typography-caption turnaround-time-box"
												style={{
													backgroundColor: TATBackgroundColor,
													width: "fit-content",
												}}
											>
												{getShortTurnaroundTime(
													instance.sampleTestInfo.turnaroundTime,
													translation
												)}
											</div>
											<div className="typography-body-01">
												{instance.expectedCompletionTime
													? formatAbsoluteDate(instance.expectedCompletionTime)
													: "--"}
											</div>
										</div>
									}
								</div>
							</div>
						</div> */}
					</div>
				</div>
			</Card>
			<Card className="card-border-radius-14p card-medium-padding">
				<div>
					<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
						<div className="order-details-header-icon-container">
							<UserIcon
								strokeColor={PrimaryColor.PRIMARY_500}
								fillColor={PrimaryColor.PRIMARY_500}
							></UserIcon>
						</div>
						<div className="typography-body-01 typography-bold">
							{translation("BatchDetails")}
						</div>
					</div>

					<div
						style={{
							marginTop: "30px",
							display: "flex",
							flexDirection: "column",
							gap: "10px",
						}}
					>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("BatchId")}
							</div>
							<div className="order-details-info-row-info">
								{batchDetails.batchFullCode}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("PrimaryTestCategory")}
							</div>
							<div className="order-details-info-row-info">
								{testCategory.testCategoryName}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("BatchType")}
							</div>
							<div className="order-details-info-row-info">
								{isOtherTestBatch ? translation("Other") : batchType?.batchName}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("MethodId")}
							</div>
							<div className="order-details-info-row-info">
								{batchDetails.testMethodCode}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("BatchSize")}
							</div>
							<div className="order-details-info-row-info">
								{batchDetails.batchSize}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("CreatedBy")}
							</div>
							<div className="order-details-info-row-info">
								{`${batchDetails.createdBy.firstName} ${batchDetails.createdBy.lastName}`}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("AssignedTo")}
							</div>
							<div className="order-details-info-row-info">
								{batchDetails.assignedUsers
									.map((user) => {
										return `${user.firstName} ${user.lastName}`;
									})
									.join(", ")}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("Comments")}
							</div>
							<div className="order-details-info-row-info wrap-text">
								{comments || translation("None")}
							</div>
						</div>
					</div>
				</div>
			</Card>
		</div>
	);

	let viewSampleTable: JSX.Element = (
		<BatchInstancesTable
			sampleInstances={batchDetails.instances}
			company={company}
			setCompany={setCompany}
			user={user as FrontendUserInfo}
			batchType={batchType}
			batchVerifyingSampleId={batchDetails.duplicateInstanceId}
			specDirectories={specDirectories}
			updateSpecification={updateSpecification}
		/>
	);

	const instantTestBatchBody: React.ReactNode = (
		<div className="order-details-body">
			{viewSampleTable}
			{<Card></Card>}{" "}
		</div>
	);

	return (
		<div style={{ margin: "0 auto" }}>
			<div>
				{batchDetailsHeaderRow}
				{orderDetailsCardRow}

				{instantTestBatchBody}
			</div>
			{
				<EditBatchStatusModal
					batchId={batchDetails.testBatchId}
					open={editStateTimeModalOpen}
					setOpen={setEditStateTimeModalOpen}
					batchStatus={batchStatus}
					setBatchStatus={setBatchStatus}
					completeTime={completeTime}
					setCompleteTime={setCompleteTime}
					user={user as FrontendUserInfo}
					resultSubmitTime={resultSubmitTime}
					setResultSubmitTime={setResultSubmitTime}
					comments={comments}
					setComments={setComments}
				/>
			}
		</div>
	);
}
